<template>
	<div>
		<el-table class="right-block" size="small" :data="listData" border>
			<el-table-column prop="id" label="工作序号" align="center">
			</el-table-column>
			<el-table-column prop="title" label="工作名" align="center">
			</el-table-column>
			<el-table-column prop="wtypes" label="类型" align="center">
				<template slot scope="scope">
					<div>{{wtypes[scope.row.wtypes]}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="图片" align="center">
				<template slot scope="scope">
					<el-image class="main-img" fit="contain" :src="imgh+'stuwork_' + scope.row.id + '_m_0.png'"
						alt="" />
				</template>
			</el-table-column>
			<el-table-column prop="begin" label="开始时间" align="center">
			</el-table-column>
			<el-table-column prop="team" width="300px" label="执行学生" align="center">
				<template slot scope="scope">
					<div class="team-list">
						<div v-for="(item,index) in scope.row.team" class="team-block"
							@click="handleEdit(scope.$index,index)">
							<div class="team-block-f">
								<el-image class="team-block-fl" fit="contain"
									:src="imgh+'studentavatar_' + item.uid + '.png'" />
								<div class="team-block-fr">
										<div>任务编号:{{item.id}}</div>
										<div>{{item.position}}</div>
								</div>
							</div>
							<div v-if="item.upid==0" class="team-block-f" v-for="(ite,inde) in item.ch">
								<el-image class="team-block-fl" fit="contain"
									:src="imgh+'studentavatar_' + ite.uid + '.png'" />
								<div class="team-block-fr">
										<div>任务编号:{{ite.id}}</div>
										<div class="team-title">{{ite.position}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="title" width="1000px" :visible.sync="editFormVisible" @click='closeDialog("edit")'>
			<div class="info-block">
				<div class="info-block-l">
					<div class="info-title">{{editForm.deptName}}</div>
					<div class="info-des">{{editForm.des}}</div>
					<div class="info-de">
						<div>{{wtypes[editForm.wtypes]}} | 联系人：{{editForm.phone}}</div>
						<div v-if="editForm.skill.length">
							<el-tag size="small" style="margin-right: 5px;" v-for="chmenu in editForm.skill"
								type="success">{{chmenu}}</el-tag>
						</div>
					</div>
					<div class="info-img">
						<div class="info-img-l">
							<el-carousel trigger="click" height="200px">
								<el-carousel-item v-for="item in editForm.zimg">
									<el-image style="height: 200px;" class="main-img" fit="scale-down" :src="item.url"
										alt="" />
								</el-carousel-item>
							</el-carousel>
						</div>
						<div>
							<el-carousel height="200px">
								<el-carousel-item v-for="item in editForm.ximg">
									<el-image style="height: 200px;" class="main-img" fit="scale-down" :src="item.url"
										alt="" />
								</el-carousel-item>
							</el-carousel>
						</div>
					</div>
				</div>
				<div class="info-block-r">
					<el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick()">
						<el-tab-pane v-for="(item,index) in baoming" :label="item.position" :nameid="index">
							<div class="stu-list">
								<el-image class="stu-img" fit="contain" :src="imgh+'studentavatar_' + item.uid + '.png'"
									alt="" />
								<div class="stu-top">
									<div>{{item.name}}</div>
									<div>{{item.phone}}</div>
								</div>
								<div class="stu-state">
									{{(item.state==2&&item.pn==100)?'等待成员同步':stateInfo[item.state-2]}}
								</div>
								<div v-if="item.pres.length>0 && item.pres[0].pn>100 && item.trueprice>0" class="stu-trueprice">
									实收：{{item.trueprice}}￥
								</div>
							</div>
							<div class="pres-blockss">
								<el-timeline>
									<el-timeline-item v-for="(ite,inde) in item.pres" :timestamp="ite.up+' '+ite.pn+'%'"
										placement="top">
										<div class="pres-block">
											<div class="pres-block-topr" v-if="inde==0 && item.state==3">
												<el-button class="stu-bottom-button" size="mini" type="success"
													@click="refuseTheStu(index,0)" plain>接收</el-button>
												<el-button class="stu-bottom-button"  size="mini" type="warning"
													@click="refuseTheStu(index,1)" plain>驳回</el-button>
											</div>
											<div class="pres-block-topr" v-else>
												{{ite.evaluate}}
											</div>
											<div class="pres-block-topl">
												<div class="pres-block-topls">
													<div>{{ite.title}}</div>
													<div>
														{{ite.des}}
													</div>
												</div>
												<el-image class="data-img" fit="scale-down"
													:src="imghl+'workingdataing_'+ite.id+'_'+ite.index+'.png'" alt="" />
											</div>
										</div>
									</el-timeline-item>
								</el-timeline>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
<!-- 			<div class="dialog-footer">
				<el-button v-if="listData[theindex].state == 1 && listData[theindex].ynum[1] == 0" size="small"
					@click='offTheWork()'>下线</el-button>
				<el-button v-if="listData[theindex].state == 2 && listData[theindex].ynum[1]>0" size="small"
					type="primary" class="title" @click="saveTheWork()">开工</el-button>
			</div> -->
		</el-dialog>
	</div>
</template>
<script>
	import {
		GetTheWorkedList,
		GetTheWorkedLogList,
		GetTheWorkedInfoToReceive,
		formatTime,
		PictureServer
	} from '../../api/userMG'
	export default {
		data() {
			return {
				theindex: 0,
				sin: 0,
				listData: [],
				cInfo: JSON.parse(localStorage.getItem('userInfo')),
				stateInfo: ['待提交', '待审核', '已驳回'],
				numtype: ['仅限个人', '仅限团队', '不限'],
				wtypes: ['', '长期工作', '短期工作', '设计项目', '线下实习','限定任务','信息补充','签到打卡'],
				state: ['未上线', '暂无报名', '已有报名', '工作中', '结束', '停止'],
				editFormVisible: false,
				editForm: {
					deptName: '',
					numtype: '',
					wtypes: '',
					price: '',
					phone: '',
					skill: '',
					des: '',
					urls: '',
					zimg: [],
					ximg: []
				},
				baoming: [],
				imgh: PictureServer.Info,
				imghl: PictureServer.Log,
				znums: 0,
				xnums: 0,
			}
		},
		created() {
			GetTheWorkedList().then(res => {
				var works = []
				res.w.forEach(e => {
					works.push({
						id: e[0],
						title: e[1],
						wtypes: e[2],
						begin: formatTime(new Date(e[3])),
						team: []
					})
				})
				res.s.forEach(e => {
					for (var i = 0; i < works.length; i++) {
						if (works[i].id == e[1]) {
							if (e[5] == 0) {
								works[i].team.push({
									id: e[0],
									uid: e[2],
									pn: e[3],
									state: e[4],
									upid: e[5],
									position: e[6],
									ch: []
								})
							} else if (e[5] == null) {
								works[i].team.push({
									id: e[0],
									uid: e[2],
									pn: e[3],
									state: e[4],
									upid: null
								})
							} else {
								for (var j = 0; j < works[i].team.length; j++) {
									if (works[i].team[j].id == e[5]) {
										works[i].team[j].ch.push({
											id: e[0],
											uid: e[2],
											pn: e[3],
											state: e[4],
											upid: e[5],
											position: e[6]
										})
										break
									}
								}
							}
						}
					}
				})
				this.listData = works
			})
		},
		methods: {
			//添加或编辑工作
			handleEdit: function(index, sin) {
				this.editFormVisible =false
				var wilist = [this.listData[index].team[sin].id],
					slist = [this.listData[index].team[sin].uid],
					xtitle, pitem
				if (this.listData[index].team[sin].ch)
					this.listData[index].team[sin].ch.forEach(e => {
						wilist.push(e.id)
						slist.push(e.uid)
					})
				this.title = '审核进度'
				this.theindex = index
				this.sin = sin
				GetTheWorkedInfoToReceive({
					id: this.listData[index].id,
					wilist: wilist,
					slist: slist
				}).then(res => {
					if (res.i[2]) {
						var imgss = res.i[2].split(",")
						for (var k = 0; k < imgss[0]; k++) {
							this.editForm.zimg.push({
								url: PictureServer.Info + 'stuwork_' + this.listData[index]
									.deptId + '_m_' + k +
									'.png'
							})
						}
						for (var k = 0; k < imgss[1]; k++) {
							this.editForm.ximg.push({
								url: PictureServer.Info + 'stuwork_' + this.listData[index]
									.deptId + '_d_' + k +
									'.png'
							})
						}
					}
					this.editForm.deptName = this.listData[index].title
					this.editForm.wtypes = this.listData[index].wtypes
					this.editForm.phone = res.i[3]
					this.editForm.des = res.i[0]
					this.editForm.skill = res.i[1] ? res.i[1].split(" ") : []
					this.editForm.zimg = []
					this.activeName = "0"
					this.editForm.ximg = []
					this.getBmed = true
					if (this.listData[index].team[sin].ch) {
						this.baoming = [...this.listData[index].team[sin].ch]
					} else {
						this.baoming = []
					}
					this.baoming.unshift({
						id: this.listData[index].team[sin].id,
						uid: this.listData[index].team[sin].uid,
						pn: this.listData[index].team[sin].pn,
						state: this.listData[index].team[sin].state,
						upid: this.listData[index].team[sin].upid,
						position: this.listData[index].team[sin].position || '负责人'
					})
					for (var i = 0; i < this.baoming.length; i++) {
						for (var j = 0; j < res.wi.length; j++) {
							if (this.baoming[i].id == res.wi[j][0]) {
								if (res.wi[j][1]) {
									xtitle = res.wi[j][1].split('|')
									slist = xtitle[0].split('^')
									wilist = []
									for (var t = 0; t < slist.length; t++) {
										pitem = slist[t].split(',')
										wilist.unshift({
											id: pitem[0],
											pn: pitem[1]
										})
									}
									wilist[0].title = xtitle[1]
									this.baoming[i].pres = [...wilist]
									this.baoming[i].trueprice = res.wi[j][2]/100
									this.baoming[i].geted = false
								} else {
									this.baoming[i].pres = []
									this.baoming[i].geted = true
								}
								break
							}
						}
						for (var j = 0; j < res.si.length; j++) {
							if (this.baoming[i].uid == res.si[j][0]) {
								this.baoming[i].name = res.si[j][1]
								this.baoming[i].phone = res.si[j][2]
								break
							}
						}
					}
					if (this.baoming[0].geted == false) {
						GetTheWorkedLogList(this.listData[index].team[sin].id).then(re => {
							this.baoming[0].geted = true
							if (re) {
								for (var i = 0; i <this.baoming[0].pres.length; i++) {
									this.baoming[0].pres[i].id = re[this.baoming[0].pres.length - i-1][0]
									this.baoming[0].pres[i].title = re[this.baoming[0].pres.length - i-1][1]
									this.baoming[0].pres[i].des = re[this.baoming[0].pres.length - i-1][2]
									this.baoming[0].pres[i].evaluate = re[this.baoming[0].pres.length - i-1][3]
									this.baoming[0].pres[i].index = re[this.baoming[0].pres.length - i-1][4]
									this.baoming[0].pres[i].up = formatTime(new Date(re[this.baoming[0].pres.length - i-1][5]))
								}
							}
							setTimeout(r => {
								this.editFormVisible = true
							}, 500)
						})
					} else {
						setTimeout(r => {
							this.editFormVisible = true
						}, 500)
					}
				})
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},
			refuseTheStu(index, t) {
				if (t) {
					this.$prompt('请说明不通过的原因', '将驳回用户提交进度', {
						inputErrorMessage: '输入不能为空',
						inputValidator: (value) => {
							if (!value) {
								return '输入不能为空';
							}
						},
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(({
						value
					}) => {
						SubmitReviewResults({
							t: this.baoming[index].id,
							r: this.baoming[index].pres[0].id,
							n: "0",
							p: value
						}).then(res => {
							if (res) {
								this.baoming[index].state = 4
								if (index == 0) {
									this.listData[this.theindex].team[this.sin].state = 4
								} else {
									this.listData[this.theindex].team[this.sin].ch[index].state = 4
								}
								that.$message.success('已驳回')
							}
						})
					})
				} else {
					this.$prompt('请输入工作评价', '接收并确认工作进度', {
						inputValue: '已确认完成',
						inputErrorMessage: '输入不能为空',
						inputValidator: (value) => {
							if (!value) {
								return '输入不能为空';
							}
						},
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(({
						value
					}) => {
						//其他成员都是100，提交后转工作流状态
						var flag = true,
							ti
						for (var k = 0; k < this.baoming.length; k++) {
							if (index == k || (this.baoming[k].state == 2 && this.baoming[k].pn == 100)) {
								continue
							}
							flag = false
						}

						if (flag) {
							//没有其他团队，提交后转工作状态
							if (this.listData[this.theindex].length == 1) {
								ti = '2'
							} else {
								ti = '3'
							}
						} else {
							ti = '1'
						}
						SubmitReviewResults({
							t: this.baoming[index].id,
							r: this.baoming[index].pres[0].id,
							n: ti,
							p: value
						}).then(res => {
							if (res) {
								this.baoming[index].state = 2
								if (index == 0) {
									this.listData[this.theindex].team[this.sin].state = 2
									this.listData[this.theindex].team[this.sin].pn = this.baoming[index]
										.pres[0].pn
								} else {
									this.listData[this.theindex].team[this.sin].ch[index].state = 2
									this.listData[this.theindex].team[this.sin].ch[index].pn = this
										.baoming[index].pres[0].pn
								}
								that.$message.success('已通过审核')
							}
						})
					})
				}

			},
			// saveTheWork(editData) {
			// 	this.$confirm('确定同意停止该团队工作?', '警告', {
			// 		confirmButtonText: '确定',
			// 		cancelButtonText: '取消',
			// 		type: 'warning'
			// 	}).then(() => {
			// 		SubmitAddNewWorks().then(res => {
			// 			if (res) {
			// 				this.listData.push({
			// 					deptId: res,
			// 					ynum: [
			// 						[0, 0], 0
			// 					],
			// 					deptName: this.editForm.deptName,
			// 					price: this.editForm.price,
			// 					wtypes: this.editForm.wtypes,
			// 					numtype: this.editForm.numtype,
			// 					state: 0
			// 				})
			// 				this.$message.success('新键工作成功，请尽快编辑补充描述图片')
			// 				this.editFormVisible = false
			// 			}
			// 		})
			// 	})

			// },
			handleClick() {
				if (this.baoming[this.activeName].geted == false) {
					GetTheWorkedLogList(this.listData[this.theindex].team[this.sin].id).then(re => {
						console.log(this.baoming[this.activeName].pres.length)
						if (re) {
							for (var i = 0; i < this.baoming[this.activeName].pres.length; i++) {
								this.baoming[this.activeName].geted = true
								this.baoming[this.activeName].pres[i].id = re[this.baoming[this.activeName].pres.length-1-i][0]
								this.baoming[this.activeName].pres[i].title = re[this.baoming[this.activeName].pres.length-1-i][1]
								this.baoming[this.activeName].pres[i].des = re[this.baoming[this.activeName].pres.length-1-i][2]
								this.baoming[this.activeName].pres[i].evaluate = re[this.baoming[this.activeName].pres.length-1-i][3]
								this.baoming[this.activeName].pres[i].index = re[this.baoming[this.activeName].pres.length-1-i][4]
								this.baoming[this.activeName].pres[i].up = formatTime(new Date(re[this.baoming[this.activeName].pres.length-1-i][5]))
							}
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.team-list {
		background: #fff;
	}

	.team-block {
		width: 100%;
		margin-bottom: 50px;
	}

	.team-block-f {
		width: 100%;
		display: flex;
		margin-bottom: 5px;
	}

	.team-block-fl {
		width: 80px;
		height: 80px;
	}

	.team-block-fr {
		width: 200px;
		margin-left: 20px;
	}

	.team-block-fr div {
		width: 100%;
		margin-top: 15px;
		text-align: left;
	}


	.main-img {
		width: 100px;
	}

	.info-block {
		width: 100%;
		display: flex;
	}

	.info-block-l {
		width: 60%;
		background: #fff;
	}

	.info-title {
		font-size: 20px;
	}

	.info-des {
		padding: 8px 10px 10px 0;
		white-space: pre-line;
	}

	.info-de div {
		margin-bottom: 5px;
	}

	.info-img {
		width: 100%;
	}

	.info-img-l {
		width: 50%;
		float: left;
	}

	.info-block-r {
		width: 40%;
		height: 450px;
		overflow: auto;
	}

	.stu-list {
		display: flex;
		margin-bottom: 10px;
		position: relative;
	}

	.stu-img {
		width: 90px;
		height: 90px;
		margin-right: 30px;
	}

	.stu-top {
		width: 310px;
		display: inline-block;
	}

	.stu-top :first-child {
		width: 100%;
		font-size: 18px;
		font-weight: bold;
		margin: 10px 0;
	}

	.stu-top :last-child {
		width: 100%;
	}

	.stu-state {
		position: absolute;
		top: 10px;
		right: 10px;
		font-size: 16px;
		color: #ff8e00;
	}
	.stu-trueprice {
		position: absolute;
		bottom: 5px;
		right: 10px;
		font-size: 14px;
		color: #2CBDDC;
	}
	.pres-blockss {
		width: 100%;
	}

	.pres-blockss ul {
		padding-left: 5px;
	}

	.pres-block {
		width: 100%;
	}

	.pres-block-topr {
		width: 100%;
		color: #ed4d4d;
		margin: 10px 0;
	}

	.stu-bottom-button {
		margin-left: 20px;
	}

	.pres-block-topl {
		width: 100%;
		display: flex;
	}

	.pres-block-topls {
		margin: auto 0;
		width: 320px;
		padding-right: 5px;
	}

	.pres-block-topls :first-child {
		font-size: 15px;
		font-weight: bold;
	}

	.pres-block-topls :last-child {
		font-size: 12px;
		white-space: pre-line;
	}

	.data-img {
		width: 150px;
		margin-left: auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/company/worked.vue